import { render, staticRenderFns } from "./sidebarCabin.vue?vue&type=template&id=421a016d&scoped=true"
import script from "./sidebarCabin.vue?vue&type=script&lang=js"
export * from "./sidebarCabin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a016d",
  null
  
)

export default component.exports